import type { Faq, FaqCreatePayload, FaqUpdatePayload } from "../types/faq";
import { apiFetch } from "./client";

export async function listFaqs(search = "", limit = 100, offset = 0): Promise<Faq[]> {
  const params = new URLSearchParams({
    search,
    limit: String(limit),
    offset: String(offset),
  });
  return apiFetch<Faq[]>(`/api/v1/admin/faqs?${params.toString()}`);
}

export async function createFaq(payload: FaqCreatePayload): Promise<Faq> {
  return apiFetch<Faq>("/api/v1/admin/faqs", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

export async function updateFaq(id: string, payload: FaqUpdatePayload): Promise<Faq> {
  return apiFetch<Faq>(`/api/v1/admin/faqs/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
}

export async function deleteFaq(id: string): Promise<void> {
  await apiFetch<void>(`/api/v1/admin/faqs/${id}`, { method: "DELETE" });
}
